import { useKeyboardKeyEvent } from '../WorkflowCanvas/hooks';
import { useContext } from 'react';
import { useHandleDiffMode } from './handleDiff';
import { UserContext } from '~/dashboard/context';
import { isPrimaryModifierPressed } from '../Search/helpers';

/**
 * Invokes the diff mode toggle on the "cmd/ctrl + /" keyboard shortcut,
 * but only when the `enableWorkflowDiff` feature flag is enabled.
 */
export default function Diff() {
  const { featureFlags } = useContext(UserContext);
  const handleDiffMode = useHandleDiffMode();

  useKeyboardKeyEvent('/', event => {
    if (!isPrimaryModifierPressed(event)) {
      return;
    }

    if (featureFlags?.enableWorkflowDiff) {
      handleDiffMode();
    }
  });

  return null;
}
